import React from "react";
import DatePicker from "react-datepicker";
import DateHelper from "../DateHelper/DateHelper";
import "date-fns";
import { parseISO, subDays, addDays, isBefore, isSameDay } from "date-fns";

class FlexibleDatePickerDates extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (!isSameDay(new Date(prevProps.date), new Date(this.props.date))) {
      this.load();
    }
  }

  render() {
    var prevDate = subDays(new Date(this.props.date), 7);
    if (isBefore(prevDate, new Date())) {
      prevDate = new Date();
    }

    return (
      <div className="FlexibleDatePickerDates">
        <div className="row">
          <div className="col-sm-3">
            <button
              className="btn btn-dark prev-week"
              onClick={this.props.onChangeDate.bind(this, prevDate)}
              disabled={
                isSameDay(new Date(this.props.date), new Date()) ||
                isBefore(new Date(this.props.date), new Date())
                  ? true
                  : false
              }
            >
              {I18n.t("previous_week")}
            </button>
          </div>
          <div className="col-sm-6 availability-date-picker-wrapper">
            <DatePicker
              className={
                this.props.classNames
                  ? this.props.classNames + " availability-picker-input"
                  : "availability-picker-input"
              }
              dateFormat={DateHelper.rubyToDateFNS(this.props.date_format)}
              dayClassName={(date) => "DatePickerInput-calendar-days"}
              selected={new Date(this.props.date)}
              showPopperArrow={false}
              minDate={parseISO(this.props.property_date)}
              onChange={this.props.onChangeDate}
            />
          </div>
          <div className="col-sm-3 next-week-button-wrapper">
            <button
              className="btn btn-dark next-week"
              onClick={this.props.onChangeDate.bind(
                this,
                addDays(new Date(this.props.date), 7)
              )}
            >
              {I18n.t("next_week")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Helper functions
   */

  load() {
    var self = this;
    let numberOfGuests = this.props.guests.reduce((acc, guestTypeObj) => {
      return acc += parseInt(guestTypeObj.number_of_guests)
    }, 0);
    
    self.props.onChangeLoading(true);
    $.ajax({
      type: "POST",
      url: this.props.check_availability_path,
      data: {
        date: this.props.date.toString(this.props.date_format),
        number_of_guests: numberOfGuests,
        api_key: this.props.account.api_key,
      },
    }).done((data) => {
      self.props.onChangeLoading(false);
      self.props.onChangeAvailability(data);
    });
  }
}

export default FlexibleDatePickerDates;
